import { takeLeading } from "@redux-saga/core/effects";

import { CollaboratorsActionTypes } from "./../types";
import { addCollaboratorsSaga } from "./addCollaborator";
import { deleteCollaboratorSaga } from "./deleteCollaborator";
import { changeCollaboratorRoleSaga } from "./changeCollaboratorRole";

export default function* collaboratorsSaga() {
    yield takeLeading(CollaboratorsActionTypes.ADD, addCollaboratorsSaga);
    yield takeLeading(CollaboratorsActionTypes.DELETE, deleteCollaboratorSaga);
    yield takeLeading(CollaboratorsActionTypes.CHANGE_ROLE, changeCollaboratorRoleSaga);
}
